// extracted by mini-css-extract-plugin
export default {"capitalize":"error-rows_capitalize__flKkc"};